import React, { Component } from "react";
import firebase from "../redux/firebase";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";
import { phoneLogin } from "../redux/actions/auth.action";
import { connect } from "react-redux";

class PhoneComponent extends Component {
  componentDidMount() {
    console.log(firebase.auth);
    const uiConfig = {
      signInOptions: [firebase.auth.PhoneAuthProvider.PROVIDER_ID],
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          this.props.phoneLogin(authResult);
          return false;
        },
      },
    };
    let ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebaseui-auth-container", uiConfig);
  }
  render() {
    return <div id="firebaseui-auth-container"></div>;
  }
}
export function mapStateToProps(state) {
  return {};
}
export function mapDispatchToProps(dispatch) {
  return {
    phoneLogin: (user) => dispatch(phoneLogin(user)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PhoneComponent);
